import { forwardRef } from "react";

import { TokenizedInputProps } from "@components/Field/Base/TokenizedInput/types";

import TokenizedInput from "../Base/TokenizedInput";
import HelperText from "../HelperText";
import Label from "../Label";

export interface TokenizedInputFieldProps extends Omit<
  TokenizedInputProps,
  "error"
> {
  label: string;
  error?: boolean;
  errorMessage?: string;
  helperText?: string;
}

const TokenizedInputField = forwardRef<
  HTMLInputElement,
  TokenizedInputFieldProps
>(
  (
    { label, error, errorMessage = null, helperText = null, block, ...props },
    ref
  ) => {
    return (
      <Label content={label} block={block}>
        <TokenizedInput
          {...props}
          block={block}
          error={Boolean(errorMessage || error)}
          ref={ref}
        />
        <HelperText
          content={errorMessage || helperText || ""}
          error={Boolean(errorMessage || error)}
        />
      </Label>
    );
  }
);
TokenizedInputField.displayName = "TokenizedInputField";

export default TokenizedInputField;
